import { useNavigationState } from '@store/hookstate';

import { Shimmer } from '@components';

import { Container, Title, Head } from './Updates.styles';

const UpdatesLoading = () => {
  const navigationState = useNavigationState();

  return (
    <Container offsetTop={navigationState.offsetTop.get()}>
      <Head>
        <Title>Updates</Title>
      </Head>

      <div style={{ height: 24 }} />
      <Shimmer
        style={{ height: 32, width: '100%', borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />

      <div style={{ height: 24 }} />

      <Shimmer
        style={{ height: 56, width: '100%', borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
    </Container>
  );
};

const CountLoading = () => {
  return (
    <Shimmer
      style={{ height: 18, width: 18, borderRadius: 4, marginLeft: 12 }}
      primary="#f1f1f1"
      secondary="#ececec"
    />
  );
};

export { UpdatesLoading, CountLoading };
